<template>
  <div>
    <Card>
      <div>
        <Form ref="form" :label-width="180" :model="form" :rules="rules">
          <Row :gutter="16">
            <Col span="24">
            <FormItem label="是否有这些材料" prop="id">
              <CheckboxGroup v-model="form.interest">
                <Checkbox label="人力资源服务许可证"></Checkbox>
                <Checkbox label="劳务派遣经营许可证"></Checkbox>
              </CheckboxGroup>
            </FormItem>
            </Col>

          </Row>
        </Form>
        <Form ref="formValidate" :label-width="180" :model="form" :rules="rules">

          <Divider orientation="left"></Divider>
          <Row :gutter="16">
            <Col span="12">
            <FormItem label="人事专员介绍信" prop="personnelLetterGuid">
              <Upload action="//jsonplaceholder.typicode.com/posts/" :data="uploadData" :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'personnelLetterGuid')" :on-format-error="handleFormatError">
                <Button icon="ios-cloud-upload-outline">点击上传</Button>
              </Upload>
            </FormItem>
            </Col>
            <Col span="12">
            <FormItem label="社会保险登记材料" prop="personnelLetterGuid">
              <Upload action="//jsonplaceholder.typicode.com/posts/" :data="uploadData" :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'personnelLetterGuid')" :on-format-error="handleFormatError">
                <Button icon="ios-cloud-upload-outline">点击上传</Button>
              </Upload>
            </FormItem>
            </Col>
            <Col span="12" v-if="formValidate.interest.indexOf('人力资源服务许可证')!=-1">
            <FormItem label="人力资源服务许可证" prop="personnelLetterGuid">
              <Upload action="//jsonplaceholder.typicode.com/posts/" :data="uploadData" :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'personnelLetterGuid')" :on-format-error="handleFormatError">
                <Button icon="ios-cloud-upload-outline">点击上传</Button>
              </Upload>
            </FormItem>
            </Col>
            <Col span="12" v-if="formValidate.interest.indexOf('劳务派遣经营许可证')!=-1">
            <FormItem label="劳务派遣经营许可证" prop="personnelLetterGuid">
              <Upload action="//jsonplaceholder.typicode.com/posts/" :data="uploadData" :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'personnelLetterGuid')" :on-format-error="handleFormatError">
                <Button icon="ios-cloud-upload-outline">点击上传</Button>
              </Upload>
            </FormItem>
            </Col>
            <Col span="12">
            <FormItem label="其他材料" prop="personnelLetterGuid">
              <Upload action="//jsonplaceholder.typicode.com/posts/" :data="uploadData" :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'personnelLetterGuid')" :on-format-error="handleFormatError">
                <Button icon="ios-cloud-upload-outline">点击上传</Button>
              </Upload>
            </FormItem>
            </Col>
          </Row>
          <div class="bom_btn">
            <div>
              <Button @click="toBack()">上一步</Button>
              <Button type="primary" @click="submitAccept('form')">提交</Button>
            </div>
          </div>
        </Form>
      </div>
    </Card>
  </div>

</template>
<script>
export default {
  computed: {
    isSub() {
      let result = true
      let _this = this
      /*
        *判断
        下拉框需要全部必填下标为[0][1],当下标[0]的值为0时,下标[2]的值为必填
        当选择为中介时,rl的下标[0][1]，为必填，当下标[0]的值为0时,下标[2]的值为必填;为否时不需要必填
     */
      this.clList.map((el, index) => {})
      return result
    },
  },
  data() {
    return {
   
      form: { id: 'ywlsh_12356789' },
      isSubBtn: true, //不允许提交受理
      isKwd: false, //是否跨网点办理
      formCl: {},
      rulesCl: {
        zj: [
          {
            required: true,
            message: '请选择',
            type: 'number',
            trigger: 'change',
          },
        ],
        rl0: [
          {
            required: true,
            message: '请选择',
            type: 'number',
            trigger: 'change',
          },
        ],
        rl1: [
          {
            required: true,
            message: '请选择',
            type: 'number',
            trigger: 'change',
          },
        ],
        rl2: [
          {
            validator: (rule, value, callback) => {},
            trigger: 'blur',
          },
        ],
      },
      rules: {},
      clList: ['jsx', 'fmcl', 'yyzz', 'tgd', 'zmcl', 'jzzzfm', 'qt'],
      selectList: [
        { name: '是', value: 1 },
        { name: '否', value: 0 },
      ],
    }
  },
  methods: {
    submitAccept(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$Message.success('Success!')
        } else {
          this.$Message.error('Fail!')
        }
      })
    },
    resmove(name) {
      this.$refs[name].resetFields()
    },
  },
}
</script>
<style lang="less" scoped>
.table,
.table > tr,
.table > tr > td,
.table > tr > th {
  border: solid 1px #eee;
  border-collapse: collapse;
  padding: 10px;
  text-align: left;
}

.table .des {
  font-size: 14px;
  color: #d4d4d4;
}

.table .ivu-form-item {
  margin-bottom: 5px;
}

.bom_btn {
  padding: 20px;
  // width: 50%;
  display: flex;
  justify-content: space-around;

  /deep/ .ivu-btn {
    padding: 0px 30px;
    margin: 0px 40px;
  }
}

.required::after {
  color: #ed4014;
  content: '*';
  display: inline-block;
  margin-right: 4px;
  line-height: 1;
  font-size: 14px;
}
</style>
